import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../config/baseWithToken";
import {
  getUpdatedProductInfo,
  isProductUpdated,
  updateItemforShopify,
} from "../../redux/slices/productSlice";
import { getOrders } from "../order";

export const getProduct = createAsyncThunk(
  "get/products",
  async (product, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/products?page=${product.page}&size=${50}&text=${
          product.text || ""
        }&status=${product.status || ""}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getAllProducts = createAsyncThunk(
  "get/admin/products",
  async (product, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/admin/products?page=${product.page}&size=${50}&text=${
          product.text || ""
        }&status=${product?.status || ""}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const getProductsByUser = createAsyncThunk(
  "get/admin/products/user",
  async (product, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/admin/products/user?userId=${product?.userId}&page=${
          product.page || 0
        }&size=${product.size}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "admin/products/update",
  async (productDetails, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/products/${productDetails?.productId}`,
        productDetails?.updatePayload
      );
      dispatch(getAllProducts({ status: "pending" }));
      dispatch(isProductUpdated(true));
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getSingleProduct = createAsyncThunk(
  "admin/products/get/single",
  async (productDetails, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.get(
        `/admin/products/${productDetails?.productId}`
      );
      // toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);
export const updateProductStatus = createAsyncThunk(
  "admin/products/status/update",
  async (productId, { dispatch, getState, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(`/products/${productId}`);
      // Customers open product cards too; only admins may reload the list of all products.
      if (getState()?.auth?.loggedUser?.user?.role === "admin") {
        dispatch(getAllProducts({ page: 0, size: 50 }));
      }
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "admin/products/delete",
  async (productId, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.delete(
        `/admin/products/delete/${productId}`
      );
      dispatch(getAllProducts({ page: 0, size: 50 }));
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getLiveProducts = createAsyncThunk(
  "products/live-products",
  async (product, thunkAPI) => {
    const params = {};
    if (product?.cursor) params.cursor = product.cursor;
    if (product?.search) params.search = product.search;
    try {
      let { data } = await axiosProtected.get("/store/live-products", { params });
      return data;
    } catch (e) {
      toast.error(e.response?.data?.message || "Could not load your products");
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

export const updateLiveProduct = createAsyncThunk(
  "store/live-products/:shopifyProductId",
  async (product, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `store/live-products/${product.shopify_product}`,
        product.productDetails
      );
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const addProduct = createAsyncThunk(
  "/add/product",
  async (product, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post("/products", product);
      toast.success(data.message);
      dispatch(getLiveProducts({ page: 0, limit: 50 }));
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);
export const cancelQuotation = createAsyncThunk(
  "/cancel-quotation/product",
  async (productId, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.delete(`/products/${productId}`);
      toast.success(data.message);
      dispatch(getLiveProducts());
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const createProductByShopifyId = createAsyncThunk(
  "/add/product/shopify",
  async (product, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post("/products/shopify", product);
      // dispatch(getOrders({page:product?.page || 0 ,limit:50, status:"Failed"}))
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);
export const addProductToImportList = createAsyncThunk(
  "store/add/import-products",
  async (product, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post(
        "/store/import-products",
        product
      );
      toast.success(data.message);
      dispatch(getImportListProducts());
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getImportListProducts = createAsyncThunk(
  "store/get/import-products",
  async (product, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/store/import-products?page=${product?.page}&size=${50}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const importProductToShopify = createAsyncThunk(
  "store/post/import-products/shopify",
  async (product, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post(
        `/store/import-products/shopify`,
        product.productDetails
      );
      toast.success(data.message);

      dispatch(getImportListProducts());
      dispatch(getLiveProducts());
      dispatch(getUpdatedProductInfo(null));
      dispatch(updateItemforShopify([]));

      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getShopifyCollection = createAsyncThunk(
  "store/shopify/collection",
  async (product, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/store/import-products/shopify/collections`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const deleteImportListProduct = createAsyncThunk(
  "store/delete/import-products",
  async (productId, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.delete(
        `/store/import-products/${productId}`
      );
      toast.success(data.message);
      dispatch(getImportListProducts());
      dispatch(getUpdatedProductInfo(null));
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);
